import { target } from './constants';
/**
  * Calculate the component's offset relative to the window.
  *
  * @param {Node|ReactElement} ref Reference to a DOM Node or React Element.
  * @returns {Object} left and top offsets.
  * @public
  */
export default function offset(ref) {
  const rect = ref.getBoundingClientRect();

  return {
    left: rect.left + target.pageXOffset - target.document.documentElement.clientLeft,
    top: rect.top + target.pageYOffset - target.document.documentElement.clientTop
  };
}
